// This file is auto-generated from config/views.json
// Do not edit manually - run npm run generate:colors instead

export const statusColors = {
  "70.Prüfstand": {
    "background": "emerald-100",
    "border": "emerald-500",
    "text": "black"
  },
  "60.Zusammenbau": {
    "background": "cyan-100",
    "border": "cyan-500",
    "text": "black"
  },
  "29.Freigabe zum Bau": {
    "background": "amber-100",
    "border": "amber-500",
    "text": "black"
  },
  "28.technische Klärung": {
    "background": "red-100",
    "border": "red-500",
    "text": "black"
  },
  "15.Material": {
    "background": "purple-100",
    "border": "purple-500",
    "text": "black"
  },
  "10.Auftrag": {
    "background": "blue-100",
    "border": "blue-500",
    "text": "black"
  },
  "50.Türkernbau": {
    "background": "gray-100",
    "border": "gray-400",
    "text": "gray-600"
  },
  "55.Presse": {
    "background": "blue-100",
    "border": "blue-500",
    "text": "black"
  },
  "75.Fertig zum Versand": {
    "background": "purple-100",
    "border": "purple-500",
    "text": "black"
  }
} as const;

export type StatusColorKey = keyof typeof statusColors;

export function getStatusColor(status: string): {
  background: string;
  border: string;
  text: string;
} | undefined {
  return statusColors[status as StatusColorKey];
}
